import axios from 'axios'
import Dexie from 'dexie'

const mapTilerApi = 'https://api.maptiler.com/'
const defaultStyle = 'voyager'

// local db to store tiles
const db = new Dexie('map')
db.version(1).stores({
  tiles: 'xyz, blob, ts'
})

// returns the url of a bitmap tile
export const tileUrl = (xyz, style = defaultStyle) => {
  return `${mapTilerApi}maps/${defaultStyle}/${xyz.z}/${xyz.x}/${xyz.y}.png?key=${process.env.VUE_APP_MAPTILER}`
}

// returns the url of a local bitmap tile if exists
// or an online tile if the local tile is not found
export const tileOfflineUrl = xyz => {
  return new Promise((resolve, reject) => {
    const key = `${xyz.x}-${xyz.y}-${xyz.z}`
    db.tiles.get(key).then(res => {
      if (res && res.blob) {
        const url = window.URL.createObjectURL(new Blob([res.blob], { type: 'image/png' }))
        resolve(url)
      } else {
        resolve(tileUrl(xyz))
      }
    })
      .catch(() => {
        resolve(tileUrl(xyz))
      })
    // .catch(err => {
    //   // reject(err)
    //   resolve(tileUrl(xyz))
    // })
  })
}

export const tilesStyles = (style = 'basic') => {
  return mapTilerApi + 'maps/' + style.toLowerCase() + '/style.json?key=' + process.env.VUE_APP_MAPTILER
}

export const styles = [
  'basic',
  'bright',
  'darkmatter',
  'pastel',
  'topo',
  'positron',
  'hybrid',
  'streets',
  'voyager'
]

export const getName = (coordinates, language = 'en') => {
  let url = mapTilerApi + 'geocoding/'
  url += coordinates.join(',') + '.json?'
  url += 'key=' + process.env.VUE_APP_MAPTILER
  return axios.get(url)
}
